<template>
  <div style="width:100%;float:left;">
    <div style="width:100%;float:left;">
      <search-orders></search-orders>
    </div>
    <div style="width:100%;float:left;">
      <CCard>
          <CCardHeader>
            Orders
            <div style="float:right;" v-if="filterOptions">
              <v-select style="width:200px;" :options="filterOptions" name="name" v-model="filter"></v-select>
            </div>
          </CCardHeader>
          <CCardBody>
          <!-- <h5 style="width:100%;float:left;text-align: center;font-size:13px;">Click on row to go to order</h5> -->
          <div style="width:100%;float:left;text-align: center;">
            <v-select style="width:500px;margin-left:auto;margin-right:auto;" placeholder="Select Customer" v-if="customerOptions" :options="customerOptions" name="name" label="label" v-model="customerFilter"></v-select>
            <CButton size="sm" class="mt-2" color="info" v-if="!downloadLoading" :disabled="selected.length ? false : true" @click="downloadOrders()">Combine & Email Selected PDF Orders (Max 30)</CButton>
          </div>
          <spacer />
          <div style="width:100%;float:left;" v-if="!loading">
            <CDataTable v-if="orders"
              :items="orders"
              :fields="fields"
              :items-per-page="20"
              pagination
              column-filter
              sorter
              table-filter
            >
              <template #check-header>
                  <input type="checkbox" :checked="checkAll()" @click="selectAll()" />
              </template>
              <!-- <template #order_id-header>
                  Order#
              </template> -->
              <template #as400_log_number-header>
                  Log#
              </template>
              <template #order_items="{item}">
                <td>
                  {{ item.order_items.length }}
                </td>
              </template>
              <template #check="{item}">
                <td>
                  <input type="checkbox" :checked="checkSelected(item)" @click="changeSelected(item)" />
                </td>
              </template>
              <template #po_number="{item}">
                <td>
                  {{ item.po_number }}
                </td>
              </template>
              <!-- <template #customer="{item}">
                <td>
                  {{ item.order.customer_info.customer_name }}
                </td>
              </template> -->
              <template #status="{item}">
                <td>
                  <CBadge :color="configureColor(item)">{{ item.as400_status }}</CBadge>
                </td>
              </template>
              <template #show="{item}">
                <td>
                  <CButton size="sm" color="primary" @click="goToOrder( item )">View</CButton>
                </td>
              </template>
            </CDataTable>
          </div>
          <small-loader v-else></small-loader>
        </CCardBody>
        </CCard>
      </div>
  </div>
</template>
<script>
import SearchOrders from './../components/search_orders'
var methods = {}

methods.rowClicked = function (item, e, z) {
  if (z !== 'check') {
    this.$router.push('/order/' + item.order_id + '/' + item.order_group_id)
  }
}

methods.checkSelected = function (item) {
  if (this.selected.indexOf(item.order_group_id) > -1) {
    return 1
  } else {
    return 0
  }
}

methods.checkAll = function () {
  if (this.selected.length) {
    return 1
  } else {
    return 0
  }
}

methods.changeSelected = function (item) {
  if (this.selected.indexOf(item.order_group_id) > -1) {
    this.selected.splice(this.selected.indexOf(item.order_group_id), 1)
  } else {
    this.selected.push(item.order_group_id)
  }
}

methods.selectAll = function () {
  if (this.selected.length) {
    this.selected = []
  } else {
    var arr = []
    this.orders.forEach(function (val) {
      arr.push(val.order_group_id)
    })
    this.selected = arr
  }
}

methods.downloadOrders = function () {
  this.downloadLoading = true
    const postData = {
      orders: this.selected
    }
    axios.post(this.$apiAdress + '/api/orders/downloadAllOrdersOnPdf?token=' + localStorage.getItem('api_token'), postData).then(response => {
      console.log(response)
      this.downloadLoading = false
      window.Swal.fire({
        type: 'success',
        title: 'Success',
        text: 'You will be emailed the orders shortly.'
      })
      this.selected = []
    }).catch(e => {
      console.log(e)
      window.Swal.fire({
        type: 'error',
        title: 'Error!',
        text: 'Something went wrong, please contact acoleman@paifashion.com if it keeps happening.'
      })
    })
}

methods.getOrders = function () {
  this.loading = true
  const postData = {
    filter: this.filter,
    customer: this.customerFilter
  }
  console.log(postData)
  axios.post(this.$apiAdress + '/api/getMyRepOrders?token=' + localStorage.getItem('api_token'), postData).then(response => {
    console.log(response)
    // this.orders = response.data
    var arr = []
    // response.data.forEach(function (val) {
    //   var obj = {}
    //   for (var key in val) {
    //     obj[key] = val[key]
    //   }
    //   // obj.po_number = val.order.po_number
    //   obj.customer_name = val.order.customer_info.customer_name
    //   obj.checked = 0
    //   // obj.rep_name = val.order.rep.name
    //   arr.push(obj)
    // })
    this.orders = response.data
    this.selected = []
    this.loading = false
  })
}

methods.goToOrder = function (item) {
  this.$router.push('/order/' + item.order_id + '/' + item.order_group_id)
}

methods.configureColor = function (item) {
  if (item) {
    var percent = ''
    switch(item.as400_status) {
      case 'Entered': {
        percent = 'info'
        break
      }
      case 'Needs Entered': {
        percent = 'secondary'
        break
      }
      case 'Waiting On Customer': {
        percent = 'danger'
        break
      }
      case 'Received': {
        percent = 'info'
        break
      }
      case 'In Process': {
        percent = 'danger'
        break
      }
      case 'Shipped': {
        percent = 'success'
        break
      }
      case 'On Hold': {
        percent = 'warning'
        break
      }
      case 'Voided': {
        percent = 'warning'
        break
      }
      case 'Canceled': {
        percent = 'danger'
        break
      }
      default: {
        percent = ''
        break
      }
    }
    return percent
  } else {
    return 0
  }
}

methods.getCustomers = function () {
  let self = this
  // this.topLoading = true
  var repNum = ''
  
  const postData = {
    rep_number: this.$store.state.user.rep_number
  }
  axios.post( this.$apiAdress + '/api/getRepCustomers?token=' + localStorage.getItem("api_token"), postData)
  .then(function (response) {


    // self.customerOptions = response.data
    self.customerOptions = []
    response.data.forEach(function (val) {
      var obj = {}
      for (var key in val) {
        obj[key] = val[key]
      }
      obj.label = val.customer_name + ' - ' + val.customer_number
      self.customerOptions.push(obj)
    })
  }).catch(function (error) {
    // self.topLoading = false
  });
}

export default {
    // ===Component name
    name: "CSRTable",
    // ===Props passed to component
    props: {},
    // ===Components used by this component
    components: {
      SearchOrders
    },
    // ====component Data properties
    data(){
        return{
          orders: null,
          fields: ['check', 'as400_log_number', 'po_number', 'customer_name', 'order_items', 'status', 'show'],
          filter: 'Last 15 Days',
          filterOptions: ['Last 15 Days', 'Last 30 Days', 'Last 60 Days', 'All'],
          loading: true,
          customerOptions: null,
          customerFilter: '',
          downloadLoading: false,
          selected: []
        }
    },
    watch: {
      'customerFilter': function (newVal, oldVal) {
        this.getOrders()
      }
    },
    // ===Code to be executed when Component is mounted
    mounted() {
      this.getOrders()
      this.getCustomers()
    },
    // ===Computed properties for the component
    computed: {},
    // ===Component methods
    methods: methods
}
</script>
<!-- styles -->
<!-- adding scoped attribute will apply the css to this component only -->
<style scoped></style>
